import { render, staticRenderFns } from "./SettingsLabelGroups.vue?vue&type=template&id=3764a534&scoped=true"
import script from "./SettingsLabelGroups.vue?vue&type=script&lang=js"
export * from "./SettingsLabelGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764a534",
  null
  
)

export default component.exports